








































































import CollapsibleGroup from "@/edinet/components/CollapsibleGroup.vue"
import ObjectTable from "@/edinet/components/ObjectTable.vue"
import {SideNav} from "@/edinet/components/sidebar"
import {DocIndex} from "@/edinet/types"
import {functions} from '@/firebase'
import {isVerySmallScreen} from "@/set/search/ScreenUtils";
import {SetState} from "@/set/set_store";
import Vue from 'vue'
import {mapMutations, mapState} from "vuex"
import {SetNewsDoc} from "../../../../gcp/doc-index/functions/src/set/types";
import {FetchNewsArgs, FetchNewsRes, SetFilingMeta, SetMeta} from "../types"
import SetNewsList from "./SetNewsList.vue"

import {createIndex, kind, loc} from "./setSearch"
import SetSearchMain from "./SetSearchMain.vue"
import SetSearchMainSplit from "./SetSearchMainSplit.vue"
import SetSearchTopNav from "./SetSearchTopNav.vue"

const setSearch = functions.httpsCallable('set-search')
const setDownloadNews = functions.httpsCallable('set-downloadNews')

export default Vue.extend({
  components: {
    SideNav,
    CollapsibleGroup,
    ObjectTable,
    SetSearchMain,
    SetSearchMainSplit,
    SetSearchTopNav,
    SetNewsList
  },
  props: {
    sym: String
  },
  data() {
    return {
      loading: false,
      error: '',
      res: {
        nextHref: undefined as (undefined | string),
        indices: [] as DocIndex[]
      },
      currentIndex: {
        id: '',
        srcLocation: '',
        meta: {}
      },
      showAllNews: true,
      main: 'news', //news, docs, viewer
      docHref: '',
      docUrls: [] as string[]
    }
  },
  async mounted() {
    if (this.sym) {
      document.title = 'SET:' + this.sym
      await this.fetchNews()
    } else {
      document.title = 'SET Search'
    }

    document.addEventListener('keydown', (e) => {
      if (e.metaKey && e.key === 'i') {
        this.showHome()
      }
    })
  },
  computed: {
    ...mapState('set', {
      lang: state => (state as SetState).lang,
      viewerConfig: state => (state as SetState).viewerConfig
    }),
    hasNext(): boolean {
      return this.res.nextHref !== undefined
    }
  },
  methods: {
    ...mapMutations('set', ['toggleSidebar', 'hideSidebar']),
    showHome() {
      this.main = 'news'
    },
    setLoc(url: string): string {
      return loc(url)
    },
    startLoading() {
      this.loading = true
      this.error = ''
      this.docHref = ''
      this.docUrls = []
    },
    parseNews(data: FetchNewsRes) {
      console.log('found %o news. next: %o', data.news.length, data.nextHref)
      // console.log(data.news[0])
      data.news.forEach(news => {
        const i = createIndex(news)
        this.res.indices.push(i)
      })
      this.res.nextHref = data.nextHref
    },
    async fetchNews() {
      this.startLoading()
      this.res.indices = []
      this.res.nextHref = undefined
      try {
        this.$store.commit('set/addHistory', this.sym)
        console.log('fetching SET news for sym %o...', this.sym)
        const refresh = this.$route.query.refresh
        const validTime = (refresh === 'true') ? 0 : 24 * 3600
        const res = await setSearch({sym: this.sym, lang: this.lang, validTimeInSecond: validTime} as FetchNewsArgs)
        this.parseNews(res.data)
      } catch (e) {
        console.warn('fetch news error %o: %o', this.sym, e)
        this.res.nextHref = undefined
        this.error = e
      }
      this.loading = false
      this.main = 'news'
    },
    async fetchMore() {
      this.loading = true
      this.error = ''
      try {
        console.log('fetching more news [%o]...', this.res.nextHref)
        const res = await setSearch({sym: this.sym, nextHref: this.res.nextHref} as FetchNewsArgs)
        this.parseNews(res.data)
      } catch (e) {
        console.warn('fetch error error %o: %o', this.sym, e)
        this.res.nextHref = undefined
        this.error = e
      }
      this.loading = false
    },
    async fetchAllNews() {
      while (this.hasNext) {
        await this.fetchMore()
      }
    },
    async getNewsLinks(index: DocIndex) {
      this.startLoading()
      try {
        const res = await setDownloadNews(loc(index.srcLocation))
        const data = res.data as SetNewsDoc
        if (data.kind === 'single') {
          this.docHref = loc(data.links[0])
          this.main = 'viewer'
        } else if (data.kind === 'multi') {
          this.main = 'viewerMulti'
          this.docUrls = data.links
        } else {
          console.warn('unknown kind %o: %o', index, data)
          this.error = 'unknown data kind: ' + data.kind
        }
        if (isVerySmallScreen()) {//i.e. iphone
          this.hideSidebar() //hide sidebar when changing document
        }
      } catch (e) {
        console.warn('extract link error %o: %o', index, e)
        this.error = e
      }
      this.loading = false
    },
    async selectIndex(index: DocIndex) {
      this.currentIndex = index

      if (kind(index.meta) === 'SetFilingMeta') {
        const meta = index.meta as SetFilingMeta
        document.title = this.sym + ':' + meta.title
      } else {
        const meta = index.meta as SetMeta
        document.title = this.sym + ':' + meta.title
      }
      await this.getNewsLinks(index)
    }
  },
  watch: {
    sym: async function(newSym: string) {
      document.title = 'SET:' + newSym
      await this.fetchNews()
    }
  }
})
